import { 
    SET_LOADING,
    SET_ARTIST_AUDIOS,
    SET_ARTIST_AUDIOS_META,
    APPEND_ARTIST_AUDIOS,
    SET_ARTIST_IMAGES,
    SET_ARTIST_IMAGES_META,
    APPEND_ARTIST_IMAGES,
    SET_ARTIST_VIDEOS,
    SET_ARTIST_VIDEOS_META,
    APPEND_ARTIST_VIDEOS,
    SET_RECRUITER_IMAGES,
    SET_RECRUITER_IMAGES_META,
    APPEND_RECRUITER_IMAGES,
    SET_RECRUITER_VIDEOS,
    SET_RECRUITER_VIDEOS_META,
    APPEND_RECRUITER_VIDEOS,
    SET_MEDIA_TAGS
} from "../../actions/media/types";

const INITIAL_STATE = {
    loading: false,
    recruiterImageList: [],
    recruiterImageListMetaData: {
        loading: false, hasMore: true
    },
    recruiterVideoList: [],
    recruiterVideoListMetaData: {
        loading: false, hasMore: true
    },
    artistImageList: [],
    artistImageListMetaData: {
        loading: false, hasMore: true
    },
    artistVideoList: [],
    artistVideoListMetaData: {
        loading: false, hasMore: true
    },
    artistAudioList: [],
    artistAudioListMetaData: {
        loading: false, hasMore: true
    },
    mediaTagList: []
}

const MediaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_RECRUITER_IMAGES: {
            return {
                ...state,
                recruiterImageList: action.payload
            }
        }
        case SET_RECRUITER_IMAGES_META: {
            return {
                ...state,
                recruiterImageListMetaData: action.payload
            }
        }
        case APPEND_RECRUITER_IMAGES: {
            return {
                ...state,
                recruiterImageList: [ ...state.recruiterImageList, ...action.payload]
            }
        }
        case SET_RECRUITER_VIDEOS: {
            return {
                ...state,
                recruiterVideoList: action.payload
            }
        }
        case SET_RECRUITER_VIDEOS_META: {
            return {
                ...state,
                recruiterVideoListMetaData: action.payload
            }
        }
        case APPEND_RECRUITER_VIDEOS: {
            return {
                ...state,
                recruiterVideoList: [ ...state.recruiterVideoList, ...action.payload]
            }
        }
        case SET_ARTIST_IMAGES: {
            return {
                ...state,
                artistImageList: action.payload
            }
        }
        case SET_ARTIST_IMAGES_META: {
            return {
                ...state,
                artistImageListMetaData: action.payload
            }
        }
        case APPEND_ARTIST_IMAGES: {
            return {
                ...state,
                artistImageList: [ ...state.artistImageList, ...action.payload]
            }
        }
        case SET_ARTIST_VIDEOS: {
            return {
                ...state,
                artistVideoList: action.payload
            }
        }
        case SET_ARTIST_VIDEOS_META: {
            return {
                ...state,
                artistVideoListMetaData: action.payload
            }
        }
        case APPEND_ARTIST_VIDEOS: {
            return {
                ...state,
                artistVideoList: [ ...state.artistVideoList, ...action.payload]
            }
        }
        case SET_ARTIST_AUDIOS: {
            return {
                ...state,
                artistAudioList: action.payload
            }
        }
        case SET_ARTIST_AUDIOS_META: {
            return {
                ...state,
                artistAudioListMetaData: action.payload
            }
        }
        case APPEND_ARTIST_AUDIOS: {
            return {
                ...state,
                artistAudioList: [ ...state.artistAudioList, ...action.payload]
            }
        }
        case SET_MEDIA_TAGS: {
            return {
                ...state,
                mediaTagList: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default MediaReducer;